import { render, staticRenderFns } from "./EmptyData.vue?vue&type=template&id=7f741646&scoped=true&"
import script from "./EmptyData.vue?vue&type=script&lang=js&"
export * from "./EmptyData.vue?vue&type=script&lang=js&"
import style0 from "./EmptyData.vue?vue&type=style&index=0&id=7f741646&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f741646",
  null
  
)

export default component.exports